import { Helmet } from "react-helmet";
import PageHero from "../components/reusables/hero/PageHero";
import ServicesBody from "../components/services/ServicesBody";
import HomeCTASection from "../components/home/HomeCTASection";
import HowWeWork from "../components/home/HowWeWork";

export default function Services() {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Flexi Painters is a Kampala-based professional painting company. We do painting, spraying, and decoration finishes for residential, commercial, and industrial properties."
        />
        <meta
          property="og:description"
          content="Flexi Painters is a Kampala-based professional painting company. We do painting, spraying, and decoration finishes for residential, commercial, and industrial properties."
        />
        <meta
          property="og:title"
          content="Services | Flexi Painters | Professional Painters in Kampala, Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1775970059/flexi_painters_banner_tnrltj.jpg"
        />

        <meta
          name="twitter:title"
          content="Services | Flexi Painters | Professional Painters in Kampala, Uganda"
        />
        <meta
          name="twitter:text:title"
          content="Services | Flexi Painters | Professional Painters in Kampala, Uganda"
        />
        <meta
          name="twitter:description"
          content="Flexi Painters is a Kampala-based professional painting company. We do painting, spraying, and decoration finishes for residential, commercial, and industrial properties."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1775970059/flexi_painters_banner_tnrltj.jpg"
        />
        <title>
          Services | Flexi Painters | Professional Painters in Kampala, Uganda
        </title>
      </Helmet>
      <PageHero
        classes="painter-bg pageHero"
        titleClasses="title uppercase flexi-orange"
        title="Flexi Painters Services"
      />
      <ServicesBody />
      <HowWeWork/>
      <HomeCTASection/>
    </>
  );
}
